<header>
  <h2>Actividades sin coincidencias</h2>
</header>
<mat-dialog-content>
<p>No se han podido emparejar {{actividades.length}} actividades. Puede que alguna materia esté dentro de estas actividades. Puede verificar revisando el reporte de asistencia por materia.
</p>
<!-- <ul>
  <li *ngFor="let actividad of actividades">
    <p>{{actividad.nombre}}</p>
  </li>
</ul> -->
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-raised-button mat-dialog-close>Cerrar</button>
</mat-dialog-actions>
